document.addEventListener('DOMContentLoaded', function () {
    const waterVolumeInput = document.getElementById('waterVolume');
    const volumeToggle = document.getElementById('volumeToggle');
    const currentSalinityInput = document.getElementById('currentSalinity');
    const desiredSalinityInput = document.getElementById('desiredSalinity');
    const saltMixSelect = document.getElementById('saltMix');
    const resultContainer = document.getElementById('result');
    const resultText = document.getElementById('resultText');
    const recommendationText = document.getElementById('recommendationText');
    const waterVolumeLabel = document.getElementById('waterVolumeLabel');

    if (
        !waterVolumeInput ||
        !volumeToggle ||
        !currentSalinityInput ||
        !desiredSalinityInput ||
        !saltMixSelect ||
        !resultContainer ||
        !resultText ||
        !recommendationText ||
        !waterVolumeLabel
    ) {
        console.error('Required DOM elements not found for Salt Mix Calculator');
        return;
    }

    function getBrand(selectedSaltMix) {
        if (selectedSaltMix.includes('Tropic Marin')) {
            return 'Tropic Marin';
        }
        if (selectedSaltMix.includes('Red Sea')) {
            return 'Red Sea';
        }
        return 'Instant Ocean';
    }

    function getRecommendation(brand, waterVolumeGallons, saltMixNeeded, desiredSalinity) {
        if (saltMixNeeded < 0.5) {
            if (brand === 'Tropic Marin') {
                return 'For this small adjustment, we recommend Tropic Marin Pro Reef Salt. It offers clean mixing and balanced parameters, which makes it a strong option for precise salinity adjustments in reef systems.';
            }
            if (brand === 'Red Sea') {
                return 'For this small adjustment, we recommend Red Sea Coral Pro Salt. It provides elevated calcium, alkalinity, and magnesium levels, which makes it a strong option for precise adjustments in coral-heavy systems.';
            }
            return 'For this small adjustment, we recommend Reef Crystals. It is enriched with extra calcium and magnesium, which makes it a solid option for precise salinity adjustments in reef tanks.';
        }

        if (waterVolumeGallons < 5) {
            if (brand === 'Tropic Marin') {
                return 'For your small tank, we recommend Tropic Marin Classic Sea Salt. It mixes cleanly and is easy to work with for smaller systems and nano setups.';
            }
            if (brand === 'Red Sea') {
                return 'For your small tank, we recommend Red Sea Blue Bucket Salt. It is a practical option that mixes well and works nicely for smaller tanks.';
            }
            return 'For your small tank, we recommend Instant Ocean Sea Salt. It is a cost-effective option that dissolves quickly and works well for smaller setups.';
        }

        if (saltMixNeeded > 5) {
            if (brand === 'Tropic Marin') {
                return 'Given the larger amount of salt needed, we recommend Tropic Marin Classic Sea Salt. It mixes cleanly in larger batches while helping maintain steady parameters.';
            }
            if (brand === 'Red Sea') {
                return 'Given the larger amount of salt needed, we recommend Red Sea Blue Bucket Salt. It is a strong choice for bulk mixing and works well for larger adjustments.';
            }
            return 'Given the larger amount of salt needed, we recommend Instant Ocean Sea Salt. It is a reliable and cost-effective option for bulk mixing in larger setups.';
        }

        if (desiredSalinity === 35) {
            if (brand === 'Tropic Marin') {
                return 'For a standard reef tank aiming for 35 PPT, we recommend Tropic Marin Pro Reef Salt. It is a popular choice for reef systems because it mixes cleanly and supports balanced reef parameters.';
            }
            if (brand === 'Red Sea') {
                return 'For a standard reef tank aiming for 35 PPT, we recommend Red Sea Coral Pro Salt. It offers elevated calcium and alkalinity levels that work well in coral-focused systems.';
            }
            return 'For a standard reef tank aiming for 35 PPT, we recommend Reef Crystals. It includes boosted calcium and magnesium levels and is a solid option for reef aquariums.';
        }

        if (brand === 'Tropic Marin') {
            return 'We recommend Tropic Marin Pro Reef Salt. It is a well-known option for reef aquariums and offers clean mixing with balanced parameters.';
        }
        if (brand === 'Red Sea') {
            return 'We recommend Red Sea Coral Pro Salt. It provides elevated calcium and alkalinity levels, making it a strong fit for reef systems.';
        }
        return 'We recommend Instant Ocean Sea Salt. It is a dependable and cost-effective option for maintaining stable salinity in a wide range of aquariums.';
    }

    function updateVolumeUI() {
        const isLiters = volumeToggle.checked;
        waterVolumeLabel.textContent = isLiters ? 'Water Volume (Liters)' : 'Water Volume (US Gallons)';
        waterVolumeInput.placeholder = isLiters ? 'Enter water volume in liters' : 'Enter water volume in gallons';
    }

    function calculateSaltMix() {
        const waterVolumeRaw = parseFloat(waterVolumeInput.value) || 0;
        const isLiters = volumeToggle.checked;
        const waterVolumeGallons = isLiters ? waterVolumeRaw / 3.78541 : waterVolumeRaw;
        const currentSalinity = parseFloat(currentSalinityInput.value) || 0;
        const desiredSalinity = parseFloat(desiredSalinityInput.value) || 0;
        const saltMixRatio = parseFloat(saltMixSelect.value);
        const selectedSaltMix = saltMixSelect.options[saltMixSelect.selectedIndex].text;

        if (
            waterVolumeRaw <= 0 ||
            desiredSalinity <= 0 ||
            currentSalinity < 0 ||
            desiredSalinity <= currentSalinity ||
            Number.isNaN(saltMixRatio)
        ) {
            resultContainer.classList.add('hidden');
            return;
        }

        const salinityDifference = desiredSalinity - currentSalinity;
        const saltMixNeeded = (salinityDifference / 35) * waterVolumeGallons * saltMixRatio;
        const brand = getBrand(selectedSaltMix);
        const recommendation = getRecommendation(brand, waterVolumeGallons, saltMixNeeded, desiredSalinity);

        resultText.textContent = `You will need approximately ${saltMixNeeded.toFixed(2)} pounds of salt mix to reach a salinity of ${desiredSalinity} PPT.`;
        recommendationText.textContent = recommendation;
        resultContainer.classList.remove('hidden');
    }

    waterVolumeInput.addEventListener('input', calculateSaltMix);
    volumeToggle.addEventListener('change', function () {
        updateVolumeUI();
        calculateSaltMix();
    });
    currentSalinityInput.addEventListener('input', calculateSaltMix);
    desiredSalinityInput.addEventListener('input', calculateSaltMix);
    saltMixSelect.addEventListener('change', calculateSaltMix);

    updateVolumeUI();
});